




import { defineComponent } from '@vue/composition-api';

const LeadTimeInformation = defineComponent({
  // setup() {},
});

export default LeadTimeInformation;
